/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdColProps, TdRowProps } from './type';

export const rowDefaultProps: TdRowProps = { align: 'top', gutter: 0, justify: 'start', tag: 'div' };

export const colDefaultProps: TdColProps = { offset: 0, order: 0, pull: 0, push: 0 };
